import React from 'react';
import { IPhraseListSelectVideoProps } from './types';
import { theme } from '../../../../../common/styles/theme';
import { MenuItem, Select, Stack, SxProps } from '@mui/material';
import { EPhraseListPlayMode } from '../../../../store/phrase-list/types';
import { CLASS_PLAY_CONTROL } from '../../Video/components/constants';
import { PlayButton } from '../../PlayButton/components/PlayButton';
import { ArrowIcon } from '../../../../../../icons/ArrowIcon';
import { ArrowLightLeftIcon } from '../../../../../../icons/ArrowLightLeftIcon';

export const PhraseListSelectVideo: React.FC<IPhraseListSelectVideoProps> = ({
	activeListModeId,
	listModes,
	onChangeListMode,
}) => {

	function handleClose(
		isPauseSelect: boolean
	  ) {
		// const el = isPauseSelect ? pauseSelectRef.current : phraseSelectRef.current;
		// if (el) {
		//   const selectList = el.querySelector('.MuiSelect-select') as HTMLElement;
		//   if (selectList) setTimeout(() => selectList.blur(), 0);
		// }
	}

	const handleChangeListMode = ({ target }: any) => {
		onChangeListMode(target.value);
	};

	return (
		<Select
			variant={'filled'}
			// ref={phraseSelectRef}
			onClose={() => handleClose(false)}
			onChange={handleChangeListMode}
			value={activeListModeId}
			fullWidth
			>
			{listModes.map((listMode) => {
				return (
				<MenuItem
					key={listMode.id}
					value={listMode.id}
				>
					{listMode.title}
				</MenuItem>
				)
			})}
		</Select>				
	);
};
